module.exports = __webpack_public_path__ + "static/media/meixinmen.c65c2837.png";